import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const TopBarSkeleton: FC<{ isInternal: boolean }> = ({ isInternal }) => (
  <div id="NewTopBar" className="bg-lvl1 px-2 py-2">
    <div className="d-flex m align-items-center px-md-1">
      <div className="d-flex co-4">
        <div className="form-group mb-0 me-1">
          <input className="form-control" style={{ width: '13em' }} />
        </div>
        <div className="form-group mb-0 me-1">
          <input className="form-control" style={{ width: '20em' }} />
        </div>
      </div>
      <div className="flex-grow-1 d-flex btn-group" role="group">
        {isInternal && (
          <button className="btn btn-lg btn-icon-start d-flex align-items-center ps-2 btn-flat-secondary" type="button">
            <i className="icon icon-sm me-2">
              <Skeleton width="1em" />
            </i>
            <span className="d-none d-xl-flex text-truncate">
              <Skeleton width="15em" />
            </span>
          </button>
        )}
      </div>
      <div className="d-flex">
        {isInternal && (
          <div className="d-flex">
            <button type="button" className="btn btn-flat-secondary">
              <span>
                <i className="icon icon-sm me-1">
                  <Skeleton width="1em" />
                </i>
                <Skeleton width="9em" />
              </span>
            </button>
          </div>
        )}
        {isInternal && (
          <button
            type="button"
            id="isPrivateMode"
            className="btn btn-lg d-flex align-items-center border-0 float-end text-secondary"
          >
            <i className="icon icon-sm me-xl-2">
              <Skeleton width="1em" />
            </i>
            <div className="d-none d-xxl-flex">
              <Skeleton width="6em" />
            </div>
          </button>
        )}
        <button className="btn btn-lg btn-flat-secondary border-start ms-2">
          <i className="icon">
            <Skeleton width="1em" />
          </i>
        </button>
        <button id="reset-form" className="btn btn-lg btn-flat-secondary">
          <i className="icon">
            <Skeleton width="1em" />
          </i>
        </button>
      </div>
    </div>
  </div>
);
